import moment from 'moment';
import router from '@/router';
import {
  APPOINTMENT_DETAIL_PARAM,
  APPOINTMENT_APPROVED_ROUTE,
  APPOINTMENT_PENDING_ROUTE,
  APPOINTMENT_DENIED_ROUTE,
  APPOINTMENT_NEW_REQUESTS_ROUTE,
} from '@/router/routes';
import {APPOINTMENT_TYPES} from '@/constants';
import {FILTER_ORDER, DENIED_VISIBILITY_WINDOW_HOURS} from '@/constants';
import {toPhilMoment} from '@/utils/dates';

export const getAppointmentId = (appointment) => {
  if ([APPOINTMENT_TYPES.NOW, APPOINTMENT_TYPES.FUTURE].includes(appointment.type)) {
    return appointment.pqeid;
  }

  return appointment.requestid;
};

// Anchored on `requestdate` (ISO) rather than `date` (MM/DD/YYYY), which is the consultation date
// and can sit in the future. See sc-71802.
export const isDeniedWithinVisibilityWindow = (appointment) => {
  // `date` is parsed as UTC so its wall-clock lines up with the +8 frame `toPhilMoment` produces.
  const anchor = appointment.requestdate
    ? toPhilMoment(appointment.requestdate)
    : moment.utc(appointment.date, 'MM/DD/YYYY');

  if (!anchor.isValid()) {
    return false;
  }

  const cutoff = toPhilMoment(moment.utc()).subtract(DENIED_VISIBILITY_WINDOW_HOURS, 'hours');

  return anchor.isAfter(cutoff);
};

export const getFilterType = (appointment) => {
  const keys = Object.keys(FILTER_ORDER);

  return keys.find((key) => {
    return FILTER_ORDER[key].statuses.includes(appointment.status)
  })
};

export const goToAppointment = (appointment) => {
  const routes = {
    [APPOINTMENT_TYPES.NOW]: APPOINTMENT_APPROVED_ROUTE,
    [APPOINTMENT_TYPES.FUTURE]: APPOINTMENT_APPROVED_ROUTE,
    [APPOINTMENT_TYPES.PENDING]: APPOINTMENT_PENDING_ROUTE,
    [APPOINTMENT_TYPES.DENIED]: APPOINTMENT_DENIED_ROUTE,
    [APPOINTMENT_TYPES.NEW_REQUEST]: APPOINTMENT_NEW_REQUESTS_ROUTE,
  };

  router.push({
    name: routes[appointment.type],
    params: {
      [APPOINTMENT_DETAIL_PARAM]: getAppointmentId(appointment),
    },
  });
};
